<template>
    <v-main>
        <v-container>
           <v-row>
               <v-col cols="8">
                   <v-card>
                       <v-card-title class="pb-0">
                           <v-text-field dense label="Form Name" outlined v-model="activeform.formname"></v-text-field>
                           <v-spacer></v-spacer>
                           <v-btn small @click="saveForm()" :loading="loading" depressed>Save</v-btn>
                       </v-card-title>
                       <v-card-text>
                           <v-card flat v-for="(f,i) in activeform.formfields" :key="f.key" @click="setIndex(i)">
                               {{f.type}} <v-btn @click="removeField(i)" depressed small>Delete</v-btn>
                               <component  :is="f.type" @formData="setFields($event)" :field="f" ></component>
                               <v-divider class="mb-2"></v-divider>
                           </v-card>
                       </v-card-text>
                       <v-card-actions>
                           <v-btn @click="newForm()">New</v-btn>
                           <v-spacer></v-spacer>
                           <v-btn :disabled="!activeform.formid" @click="deleteForm()">Delete</v-btn>
                       </v-card-actions>
                   </v-card>
               </v-col>
               <v-col cols="4">
                   <v-card>
                       <v-card-text>
                           Form Fields
                           <div v-for="f in options" :key="f">
                               <v-btn small @click="addFields({type:f,'question':undefined,'answer':undefined})">{{f}}</v-btn>
                           </div>
                       </v-card-text>
                       <v-skeleton-loader v-if="!myforms"  type="list-item-avatar-three-line" ></v-skeleton-loader>
                       <v-list two-line dense>
                           <v-list-item  v-for="f in myforms" :key="f.id" @click="loadForm(f)">
                               <v-list-item-content>
                                   <v-list-item-title>
                                       {{f.formname}}
                                   </v-list-item-title>
                                   <v-list-item-subtitle>
                                       {{f.origin}}
                                   </v-list-item-subtitle>
                               </v-list-item-content>
                               <v-list-item-action >
                                   <v-btn icon>
                                       <v-icon>
                                           {{icons.edit}}
                                       </v-icon>
                                   </v-btn>
                               </v-list-item-action>
                           </v-list-item>
                       </v-list>
                   </v-card>
               </v-col>
           </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import{
    mapState,
    mapActions
  } from 'vuex'
  export default {
    components: {
      YesNo:()=>import('@/components/forms/YesNo.vue'),
      FormText:()=>import('@/components/forms/FormText.vue'),
      MultipleChoice:()=>import('@/components/forms/MultipleChoice.vue')
    },
    name: "Index",
    data() {
      return {
        myforms: false,
        activeform:{
          formfields:[],
          formid:undefined,
          formname:''
        },
        options:['FormText','YesNo','MultipleChoice'],
        index:-1,
        loading:false
      }
    },
    mounted() {
      let em = this;
      setTimeout(function(){
        em.getForms()
      },1000)
    },
    computed:{
      ...mapState(['icons'])
    },
    methods: {
      ...mapActions(['post','get','delete']),
      newForm(){
        this.activeform = {
          formfields:[],
          formid:undefined,
          formname:''
        }
        this.index=0;
      },
      setFields(e){
        e.key = new Date().getTime() //just for v-for keys
        this.$set(this.activeform.formfields[this.index], 'question',e.question)
        this.$set(this.activeform.formfields[this.index], 'answer',  e.answer)
      },
      addFields(e){
        this.index = (this.activeform.formfields.length)
        e.key = new Date().getTime() //just for v-for keys
        this.$set(this.activeform.formfields,this.index,e)
      },
      async saveForm(){
        this.loading=true
        let body = this.activeform
        let j = await this.post({path:'api/forms/',body:body})
        this.loading=false
        if(j.formid)this.formid = j.formid
        this.getForms();
      },
      async deleteForm(){
        let body = this.activeform
        let j = await this.delete({path:'api/forms/',body:body})
      },
      async getForms(){
        this.myforms =  await this.get({path:'api/forms/'})
        console.log('myforms:',this.myforms)
      },
      removeField(i){
        this.activeform.formfields.splice(i,1)
        this.index--
      },
      loadForm(e){
        this.form = undefined
        this.activeform = e
        this.form = e.formfields
      },
      setIndex(index){ console.log(index)
        this.index=index
      }}
  }
</script>

<style scoped>

</style>